module.exports = __webpack_public_path__ + "static/30-2ccfccf1a859c2dea162bfdcada38aea.jpg";